import React from "react";
import Img1 from "../assets/dashboardimages/Deepiq_chart (1).png";
import Img2 from "../assets/dashboardimages/Deepiq_chart (2).png";
import Img3 from "../assets/dashboardimages/Deepiq_chart (3).png";
import Img4 from "../assets/dashboardimages/Deepiq_chart (4).png";
import Img5 from "../assets/dashboardimages/Deepiq_chart (5).png";
import Img6 from "../assets/dashboardimages/Deepiq_chart (6).png";
import Img7 from "../assets/dashboardimages/Deepiq_chart (7).png";

const DashboardView: React.FC = () => {
  const tiles: Array<{ title: string; value: string; sub?: string;}>= [
    { title: "Bit Depth", value: "10,550 ft" },
    { title: "ROP", value: "48 ft/hr" },
    { title: "ΔFlow", value: "-3 gpm" },
    { title: "Pit Volume", value: "805 bbl", sub: "(Δ -4 bbl / 10 min)" },
    { title: "Hookload", value: "295 klbf" },
    { title: "Torque", value: "805 kNm" },
    { title: "RPM", value: "112" },
    { title: "Fluid Density", value: "12.5 ppg" },
  ];

  const styles: Record<string, React.CSSProperties> = {
    container: {
      display: "flex",
      flexDirection: "column",
      gap: 16,
      color: "#fff",
      width: "100%",
      boxSizing: "border-box",
      padding: "100px 16px 12px 80px",
    },
    tilesRow: {
      display: "grid",
      gridTemplateColumns: "repeat(auto-fit, minmax(140px, 1fr))",
      gap: 12,
      alignItems: "stretch",
      width: "100%",
    },
    tile: {
      border: "1px solid rgba(255,255,255,0.6)",
      borderRadius: 4,
      padding: "6px 6px",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      minHeight: 72,
      background: "transparent",
    },
    tileTitle: { fontSize: 16, opacity: 0.9 },
    tileValue: { fontSize: 16, fontWeight: 600 },
    tileSub: { fontSize: 11, opacity: 0.85 },
    hr: { height: 1, background: "rgba(255,255,255,0.2)", border: 0, margin: "8px 0 0" },
    bottomRow: {
      display: "grid",
      gridTemplateColumns: "minmax(0, 1fr) 380px",
      gap: 16,
      marginTop: 4,
      alignItems: "start",
    },
    imagesPanel: {
      border: "1px solid rgba(255,255,255,0.6)",
      borderRadius: 4,
      padding: 12,
      width: "100%",
      boxSizing: "border-box",
      background: "transparent",
      maxHeight: "75vh",
      overflowY: "auto",
    },
    imagesGrid: {
      display: "grid",
      gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
      gap: 16,
      width: "100%",
    },
    imageCard: {
      border: "1px solid rgba(255,255,255,0.4)",
      borderRadius: 4,
      padding: 8,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      background: "rgba(255,255,255,0.03)",
    },
    image: {
      width: "100%",
      height: 320,
      objectFit: "contain",
    },
    rightBox: {
      width: "100%",
      border: "1px solid rgba(255,255,255,0.6)",
      borderRadius: 4,
      padding: 12,
      display: "flex",
      flexDirection: "column",
      gap: 10,
      background: "transparent",
    },
    rightTitle: { fontWeight: 600 },
    alertItem: { display: "flex", alignItems: "center", gap: 8, fontSize: 14 },
  };

  const dotStyle = (color: string): React.CSSProperties => ({
    width: 12,
    height: 12,
    borderRadius: "50%",
    background: color,
    display: "inline-block",
  });

  const images = [Img1, Img2, Img3, Img4, Img5, Img6, Img7];

  return (
    <div style={styles.container}>
      <div style={styles.tilesRow}>
        {tiles.map((t, idx) => (
          <div key={idx} style={styles.tile}>
            <div style={styles.tileTitle}>
              {t.title}
            </div>
            <div style={styles.tileValue}>{t.value}</div>
            {t.sub && <div style={styles.tileSub}>{t.sub}</div>}
          </div>
        ))}
      </div>
      <hr style={styles.hr} />

      <div style={styles.bottomRow}>
        {/* Left: All images grid */}
        <div style={styles.imagesPanel}>
          <div style={styles.imagesGrid}>
            {images.map((src, i) => (
              <div key={i} style={styles.imageCard}>
                <img src={src} alt={`dashboard-${i + 1}`} style={styles.image} />
              </div>
            ))}
          </div>
        </div>

        <div style={styles.rightBox}>
          <div style={styles.rightTitle}>Alerts & Events</div>
          <div style={styles.alertItem}>
            <span style={dotStyle("#E74C3C")} />
            <span>Pit Loss (-6 bbl / 10 mins)</span>
          </div>
          <div style={styles.alertItem}>
            <span style={dotStyle("#F39C12")} />
            <span>Flow Imbalance (-12 gpm)</span>
          </div>
          <div style={styles.alertItem}>
            <span style={dotStyle("#27AE60")} />
            <span>Stick-slip detected</span>
          </div>
          <div style={styles.alertItem}>
            <span style={dotStyle("#2ECC71")} />
            <span>On-Bottom (ROP 48 ft/hr @ 10,550ft)</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DashboardView;
